import {Checkbox} from "antd";
import * as React from "react";


// Component to map getFieldDecorator "value" to antd checkbox "checked"
class CustomCheckbox extends React.Component<any> {
    render() {
        return (
            <Checkbox checked={this.props.value} {...this.props} />
        )
    }
}

export default CustomCheckbox;